import { cn } from '@/lib/cn'

interface GlassCardProps extends React.HTMLAttributes<HTMLDivElement> {
  glow?: boolean
  hover?: boolean
  size?: 'sm' | 'md' | 'lg'
}

export function GlassCard({
  className,
  glow = false,
  hover = false,
  size = 'md',
  children,
  ...props
}: GlassCardProps) {
  return (
    <div
      className={cn(
        'glass',
        size === 'sm' && 'p-4',
        size === 'md' && 'p-6',
        size === 'lg' && 'p-8',
        hover && 'glass-hover cursor-pointer',
        glow && 'glow',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}
